module.exports = __webpack_public_path__ + "static/002-0294997b79192bc727ea29e6267df93a.png";